export function undefinedIfEmpty(value: any): any {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }
  return value;
}
